<form class="flex flex-column" (validate)="save()" novalidate validation-es>
  <section class="col-12 px-0 py-0 align-items-center flex-row flex-wrap form__field">
    <label class="col-12 md:col-3 px-0 py-0 m-0" for="patient">{{screen.labels.patient}}</label>
    <div class="col-12 md:col-9 px-0 md:pl-2 py-0 p-inputgroup">
      <p-autoComplete name="patient" [(ngModel)]="patientHelp" inputId="patient" field="fullName" dataKey="id"
        [suggestions]="patientsSuggestion" [forceSelection]="true" (completeMethod)="searchPatient($event)"
        appendTo="body" validation [required]="true" [readonly]="isPatch">
        <ng-template let-patient pTemplate="item">
          <span>{{patient.fullName}} ({{patient.document}})</span>
        </ng-template>
      </p-autoComplete>
      <button pButton icon="fas fa-search" type="button" class="p-button-info" [pTooltip]="screen.actions.search"
        (click)="openAdvancedSearch()" *ngIf="!isPatch">
      </button>
      <button pButton icon="fas fa-plus" type="button" class="p-button-success" [pTooltip]="screen.actions.addPatient"
        (click)="openNewPatientModal()" *ngIf="!isPatch">
      </button>
    </div>
  </section>

  <section class="col-12 px-0 py-0 align-items-center flex-row flex-wrap form__field"
    *ngIf="!isPatch || isPatchDoctor">
    <label class="col-12 md:col-3 px-0 py-0 m-0" for="specialty">{{screen.labels.specialty}}</label>
    <div class="col-12 md:col-9 px-0 md:pl-2 py-0">
      <p-autoComplete name="specialty" [(ngModel)]="specialtyHelp" inputId="specialty" field="label" dataKey="value"
        [suggestions]="specialtiesSuggestion" [dropdown]="!isPatchDoctor" [forceSelection]="true"
        (completeMethod)="showSpecialtiesSuggestions($event)" (onSelect)="loadDoctorsBySpecialty()" appendTo="body"
        validation [required]="true" [readonly]="isPatch" *ngIf="!doctorOneSpecialty">
      </p-autoComplete>
      <input pInputText name="specialty" [value]="specialtyHelp!.value.name" *ngIf="doctorOneSpecialty" validation
        [readonly]="true" />
    </div>
  </section>

  <section class="col-12 px-0 py-0 align-items-center flex-row flex-wrap form__field"
    *ngIf="(!isPatch || isPatchDoctor) && !isDoctorRole">
    <label class="col-12 md:col-3 px-0 py-0 m-0" for="doctor">{{screen.labels.doctor}}</label>
    <div class="col-12 md:col-9 px-0 md:pl-2 py-0">
      <p-autoComplete name="doctor" [(ngModel)]="doctorHelp" inputId="doctor" field="fullName" dataKey="id"
        [suggestions]="doctorsSuggestion" [dropdown]="true" [forceSelection]="true"
        (completeMethod)="showDoctorSuggestions($event)" [disabled]="!enableDoctorSearch" appendTo="body" validation
        [required]="true">
        <ng-template let-doctor pTemplate="item">
          <span>{{doctor.fullName}} ({{doctor.document}})</span>
        </ng-template>
      </p-autoComplete>
    </div>
  </section>

  <section class="col-12 px-0 py-0 align-items-center flex-row flex-wrap form__field"
    *ngIf="(!isPatch || isPatchStatus) && !isAgenda">
    <label class="col-12 md:col-3 px-0 py-0 m-0" for="turnStatus">{{screen.labels.status}}</label>
    <div class="col-12 md:col-9 px-0 md:pl-2 py-0">
      <p-autoComplete name="turnStatus" [(ngModel)]="turnStatusHelp" inputId="turnStatus" field="label" dataKey="value"
        [suggestions]="turnStatusSuggestion" [dropdown]="true" [forceSelection]="true"
        (completeMethod)="showTurnStatusSuggestions($event)" appendTo="body" validation [required]="true">
      </p-autoComplete>
    </div>
  </section>

  <section class="col-12 px-0 py-0 align-items-center flex-row flex-wrap form__field" *ngIf="isAgenda">
    <label class="col-12 md:col-3 px-0 py-0 m-0" for="turnDateTime">{{screen.labels.dateTime}}</label>
    <div class="col-12 md:col-9 px-0 md:pl-2 py-0">
      <dx-date-box name="turnDateTime" [value]="turn.turnStart!"
        [placeholder]="screen.labels.datePlaceholder + ' hh:mm'" (onValueChanged)="onTurnStartChanged($event)"
        [displayFormat]="screen.labels.dateFormatFull + ' HH:mm'" [openOnFieldClick]="true" type="datetime">
      </dx-date-box>
    </div>
  </section>

  <hr>

  <section class="col-12 px-0 py-0 align-items-center flex-row flex-wrap form__field" *ngIf="isAgenda">
    <label class="col-12 md:col-3 px-0 py-0 m-0" for="turn-balance">{{screen.labels.balance}}</label>
    <div class="col-12 md:col-9 px-0 md:pl-2 py-0">
      <p-inputNumber name="turn-balance" [(ngModel)]="turn.balance" [showButtons]="true" buttonLayout="horizontal"
        spinnerMode="horizontal" decrementButtonClass="p-button-danger" incrementButtonClass="p-button-success"
        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" mode="currency" currency="USD" locale="es-EC"
        validation></p-inputNumber>
    </div>
  </section>

  <hr *ngIf="isAgenda">

  <section class="align-self-end">
    <button pButton [type]="loading ? 'button' : 'submit'"
      [label]="loading ? screen.actions.saving : screen.actions.save" [icon]="loading ? loadingIcon : 'far fa-save'"
      class="p-button-success p-button-outlined"></button>
  </section>
</form>